import type { SVGProps } from 'react';

export const BitcoinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#E6E6E6"
      fillRule="evenodd"
      d="M22.435 3H1.565C.701 3 0 3.7 0 4.565v14.609c0 .864.7 1.565 1.565 1.565h20.87c.864 0 1.565-.7 1.565-1.565V4.565C24 3.701 23.3 3 22.435 3Z"
      clipRule="evenodd"
    />
    <path
      fill="#F99400"
      d="M12 18.13A6.26 6.26 0 1 0 12 5.61a6.26 6.26 0 0 0 0 12.521Z"
    />
    <path
      fill="#fff"
      d="M14.76 10.977c.124-.833-.51-1.28-1.378-1.58l.282-1.128-.688-.171-.274 1.099c-.18-.045-.366-.088-.55-.13l.276-1.106-.687-.17-.281 1.127c-.15-.034-.297-.068-.44-.103l.001-.004-.947-.236-.183.733s.51.117.5.125c.277.069.328.253.32.4l-.772 3.091c-.034.085-.12.211-.314.163.006.01-.5-.124-.5-.124l-.34.786.893.223c.167.041.33.085.49.126l-.284 1.141.686.172.282-1.13c.187.05.37.098.547.142l-.28 1.124.687.171.284-1.139c1.171.222 2.052.132 2.423-.927.3-.853-.015-1.345-.63-1.666.449-.103.787-.399.877-1.009Zm-1.57 2.202c-.212.853-1.648.391-2.114.276l.377-1.512c.466.116 1.959.346 1.737 1.236Zm.213-2.214c-.194.776-1.39.382-1.777.285l.342-1.371c.387.096 1.636.277 1.435 1.086Z"
    />
  </svg>
);
